export default __webpack_public_path__ + "static/media/netsusute_logo.a29a042c.png";